import { AttachedFilePermissionItemDto, AttachedFilePermissionType, AttachedFilePrivateType } from 'models';

export function makeKey(x: AttachedFilePermissionItemDto): string {
    return x.user != null ? "u" + x.user.id : "g" + x.userGroup.id;
}

export function getIsPrivateDescription(isPrivate?: AttachedFilePrivateType) {
    if (!isPrivate || isPrivate === AttachedFilePrivateType.None)
        return "Filerna kan läsas och skrivas av alla användare.";
    if (isPrivate === AttachedFilePrivateType.WriteOnly)
        return "Filerna kan läsas av alla användare och skrivas av användare med specifika rättigheter.";
    if (isPrivate === AttachedFilePrivateType.ReadWrite)
        return "Filerna kan läsas och skrivas av användare med specifika rättigheter.";
}
